declare global {
    interface Window {
        Pinia: any;
    }
}

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from '~/vue/_teammasters/apps/Teambuilding.vue'

// Main app
const main = async () => {
    const app = createApp(App)

    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)
    app.use(pinia)

    return app.mount('#vue-teambuilding')
}

// Execute async function
main()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}